exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ontology-list {\r\n    list-style-type: none;\n}\n.page-title { \r\n  color: #000000;\r\n  font-size: 20px;\r\n  font-weight: bold;\n}\n.ontology-small {\r\n  border-top: 1px solid #c5c5c5;\r\n  text-align: right;\r\n  padding: 10px;\r\n  color:#31b34a;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16e69bf2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OntologyPane.vue
// module id = dVQB
// module chunks = 1